import { createDomain } from 'effector';

export const defaultDomain = createDomain('framework/default');
